var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.step > 1
    ? _c(
        "el-button",
        {
          on: {
            click: function ($event) {
              return _vm.$store.commit("back")
            },
          },
        },
        [_vm._v("\n  " + _vm._s(_vm.text || "Back") + " \n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }